const { createStyledBreakpoints } = require('./styled-breakpoints');

module.exports = createStyledBreakpoints();
